"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/**
 * @component Toggle
 * @example
 * <Toggle
 *    leftText="Mobile"
 *    rightText="Home"
 *    name="isFirstPhoneMobile"
 *    value={formik.values.isFirstPhoneMobile}
 *    formik={formik}
 *  />
 *
 * @param {string} name toggle name, required for formik
 * @param {any} formik pass formik here
 * @param {string} leftText optional; defaults to yes
 * @param {string} rightText optional; defaults to no
 * @param {boolean} disabled is toggle disabled
 * @param {any} value value of toggle
 * @param {number} marginTop margin on top of the toggle
 * @param {number} marginRight margin to the right of the toggle
 * @param {function} onChange fn to be triggered on toggle change
 * @param {number} marginBottom margin on bottom of toggle
 * @param {number} marginLeft margin to left of toggle
 * @param {function} onClick fn to be triggered on click of toggle
 *
 */
var Toggle = function (props) {
    var name = props.name, formik = props.formik, _a = props.leftText, leftText = _a === void 0 ? "Yes" : _a, _b = props.rightText, rightText = _b === void 0 ? "No" : _b, disabled = props.disabled, value = props.value, marginTop = props.marginTop, marginRight = props.marginRight, marginBottom = props.marginBottom, marginLeft = props.marginLeft, onChange = props.onChange, onClick = props.onClick;
    var handleOnClick = function () {
        onClick && onClick();
    };
    return (react_1.default.createElement("div", { className: "mt-".concat(marginTop, " mr-").concat(marginRight, " mb-").concat(marginBottom, " ml-").concat(marginLeft) },
        react_1.default.createElement("div", { className: "buttongroup", style: { borderRadius: '5px', border: '3px solid #afbecd' } },
            react_1.default.createElement("input", { id: "".concat(name, "-left"), type: "checkbox", disabled: disabled, name: name, checked: value || (value === leftText), onChange: function (e) {
                    formik.handleChange(e);
                    formik.setFieldValue(name, !value);
                    onChange && onChange();
                }, onBlur: formik.handleBlur, onClick: handleOnClick }),
            react_1.default.createElement("label", { htmlFor: "".concat(name, "-left") }, leftText),
            react_1.default.createElement("input", { id: "".concat(name, "-right"), type: "checkbox", name: name, disabled: disabled, checked: !value || (value === rightText), onChange: function (e) {
                    formik.handleChange(e);
                    formik.setFieldValue(name, !value);
                    onChange && onChange();
                }, onClick: handleOnClick, onBlur: formik.handleBlur }),
            react_1.default.createElement("label", { htmlFor: "".concat(name, "-right") }, rightText))));
};
exports.default = Toggle;
